import { Carousel, Col, Row, Tag } from "antd";
import { useRef, useState, useEffect } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import apiClient from "../../Actions/apiClient";
import AssetPath from "../../AssetPath/AssetPath";
import ButtonBox from "../../Components/ButtonBox/ButtonBox";
import ModalBox from "../../Components/ModalBox/ModalBox";
import { sanitizeHTML } from "../../Util/Util";
import NewsletterSubscription from "../SubscribeNewsletter/NewsletterSubscription";
import AboutSection from "./AboutSection";
import ContactSectionForm from "./ContactSectionForm";
import ExpertTeam from "./ExpertTeam";
import "./Home.scss";
import "./HomeSlider.scss";
import OurPartners from "./OurPartners";
import SubmitAbstractForm from "./SubmitAbstractForm";
import { SlLocationPin } from "react-icons/sl";

export default function Home() {
  const [open, setOpen] = useState();
  const [sliderData, setSliderData] = useState([]);

  const navigate = useNavigate();

  const carouselRef = useRef();

  useEffect(() => {
    // Fetch upcoming events from the dedicated endpoint
    apiClient.get("events/upcoming-events").then(({ data }) => {
      if (data && data.result) {
        const sliderEvents = data.result
          .sort(
            (a, b) => new Date(a.eventDateStart) - new Date(b.eventDateStart),
          )
          .map((event) => ({
            title: event.title,
            secondTitle: event.subtitle,
            shortDescription: event.shortDescription,
            dateTime:
              event.eventDateStart && event.eventDateEnd
                ? `${new Date(event.eventDateStart).toLocaleDateString(
                    "en-US",
                    {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    },
                  )} - ${new Date(event.eventDateEnd).toLocaleDateString(
                    "en-US",
                    {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    },
                  )}${event.eventTime ? ` at ${event.eventTime}` : ""}`
                : "",
            location: event.location,
            thumbnail: event.thumbnailUrl || "",
            className: "bg-primary",
            gradient: "bg-light-blue-gradient",
            btnText: "View Details",
            url: `/event-details/${event._id || event.id}`,
            discountLabel: event.discountLabel,
            discountCode: event.discountCode,
            hotelBooking: event.eventLink2
              ? [
                  {
                    label: event.eventLink1
                      ? "Register Now"
                      : "Hotel Reservation",
                    link: event.eventLink1 || event.eventLink2,
                  },
                  ...(event.eventLink2
                    ? [
                        {
                          label: "Hotel Reservation",
                          link: event.eventLink2,
                        },
                      ]
                    : []),
                ]
              : event.eventLink1
                ? [
                    {
                      label: "Register Now",
                      link: event.eventLink1,
                    },
                  ]
                : [],
          }));
        setSliderData(sliderEvents);
      }
    });
  }, []);

  const handleNext = () => {
    carouselRef.current.next();
  };

  const handlePrevious = () => {
    carouselRef.current.prev();
  };

  const carouselConfig = {
    draggable: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2500,
    infinite: true,
    slidesToShow: 1,
    swipeToSlide: true,
  };

  return (
    <>
      <section
        className="home-sldier bg-light-blue position-relative overflow-hidden"
        data-aos="fade-up"
      >
        <div className="slide-navigations position-absolute d-flex">
          <div
            className="previous me-2 cursor-pointer"
            onClick={handlePrevious}
          >
            <FiChevronLeft size={18} className="text-primary" />
          </div>
          <div className="next cursor-pointer" onClick={handleNext}>
            <FiChevronRight size={18} className="text-primary" />
          </div>
        </div>
        <Carousel {...carouselConfig} ref={carouselRef}>
          {sliderData.length > 0 ? (
            sliderData.map((data, i) => (
              <div
                className={`slider-list position-relative d-flex flex-column flex-lg-row align-items-center justiyf-content-center ${data.className}`}
                key={i}
              >
                <div className="slide-content" data-aos="fade-up">
                  <h1 className="mb-0 fw-bold text-white mb-2">{data.title}</h1>
                  {data.secondTitle ? (
                    <h3 className="mb-2 fw-bold text-white font-weight-bold h4 fst-italic">
                      {data.secondTitle}
                    </h3>
                  ) : (
                    ""
                  )}
                  <p
                    className="text-white mb-3"
                    dangerouslySetInnerHTML={{
                      __html: sanitizeHTML(data.shortDescription),
                    }}
                  />
                  <h5 className="text-white text-uppercase font-weight-medium">
                    {data.dateTime}
                  </h5>

                  {data.location ? (
                    <p className="mt-3 text-white text-capitalize">
                      <SlLocationPin size={20} className="me-2" />{" "}
                      {data.location}
                    </p>
                  ) : (
                    ""
                  )}

                  <p className="text-white">
                    Join us for the insights, networking, and the future of
                    pharma
                  </p>
                  {data.discountLabel && (
                    <div className="border rounded card bg-white mt-3 mb-2">
                      <p className="text-black mb-0">
                        {data.discountLabel && `${data.discountLabel} : `}
                        <Tag className="ms-2 bg-gray border text-primary">
                          {data.discountCode}
                        </Tag>
                      </p>
                    </div>
                  )}
                  {data.btnText && (
                    <ButtonBox
                      type="default"
                      className="me-2"
                      label={data.btnText}
                      onClick={() => navigate(`${data.url}`)}
                      rightArrowIcon
                    />
                  )}                   
                </div>

                <div className="main-image text-end overflow-hidden position-relative">
                  <div
                    className={`gradient position-absolute ${data.gradient}`}
                    style={{ width: "30%", height: "100%", left: "-3px" }}
                  />
                  <img src={data.thumbnail} alt={data.title} />
                </div>
              </div>
            ))
          ) : (
            <div className="slider-list position-relative d-flex flex-column flex-lg-row align-items-center justify-content-center bg-primary">
              <div className="slide-content" data-aos="fade-up">
                <h1 className="mb-0 fw-bold text-white mb-2">
                  No Upcoming Events
                </h1>
                <p className="text-white">
                  Check back soon for upcoming events!
                </p>
              </div>
            </div>
          )}
        </Carousel>
      </section>

      <AboutSection activeButton />

      <section
        className="spacing become-volunteer bg-volunteer position-relative"
        data-aos="fade-up"
      >
        <div className="container text-center position-relative ">
          <h2 className="mb-1 text-capitalize text-white fw-bold">
            Join us and make a difference!
          </h2>
          <p className="text-white text-center ">
            Volunteer to assist our board with conferences and help create
            impactful events.{" "}
            <span className="d-block">
              Your support can shape a better future.
            </span>
          </p>
          <h4 className="text-white mb-3 text-center">Ready to contribute?</h4>
          <div className="pb-4">
            <ButtonBox
              label="Become a Volunteer"
              rightArrowIcon
              type="default"
              onClick={() => navigate("/become-a-volunteer")}
            />
          </div>
        </div>
      </section>

      <ExpertTeam />

      <NewsletterSubscription />

      <OurPartners />

      <section className="contact-section  spacing" data-aos="fade-up">
        <div className="container">
          <div className="text-center">
            <h4 className="title text-capitalize mb-4 text-primary fw-bold">
              We would love to hear from you
            </h4>
          </div>
          <Row
            gutter={[
              { xs: 10, sm: 16, md: 24, lg: 30 },
              { xs: 10, sm: 16, md: 24, lg: 30 },
            ]}
            justify="center"
            align="middle"
          >
            <Col
              xs={{ span: 24 }}
              sm={{ span: 12 }}
              md={{ span: 10 }}
              lg={{ span: 10 }}
            >
              <img
                src={AssetPath.images.weloveToHearBg}
                alt="Pharma-SOS - Commercial Operations Community"
                className="rounded mb-3 w-100"
                data-aos="fade-up"
              />
              <p className="text-gray" data-aos="fade-up">
                For more information or scholarship inquiries, send us a
                message, and we’ll respond promptly.
              </p>
              <p className="font-weight-medium text-primary" data-aos="fade-up">
                For press passes or special requests, please complete the form
                and submit it.
              </p>

              {/* <div className="phone-and-address">
                {contactData.map((data, i) => (
                  <div
                    className="contact-list d-flex align-items-center justify-content-start mt-2"
                    key={i}
                  >
                    <div className="icon rounded-circle border d-flex align-items-center justify-content-center me-2">
                      {data.icon}
                    </div>
                    <div className="details">
                      <span className="d-block text-black font-weight-bold mb-0">
                        {data.title}
                      </span>
                      <p className="text-gray mb-0">{data.content}</p>
                    </div>
                  </div>
                ))}
              </div> */}
            </Col>
            <Col
              xs={{ span: 24 }}
              sm={{ span: 12 }}
              md={{ span: 9 }}
              lg={{ span: 9 }}
            >
              <div className="card">
                <ContactSectionForm />
              </div>
            </Col>
          </Row>
        </div>
      </section>

      {/* submit abstract details */}
      <ModalBox
        open={open}
        onOk={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        footer={null}
        width={900}
      >
        <SubmitAbstractForm />
      </ModalBox>
    </>
  );
}
